import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=6ff83acc&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "../../../node_modules/bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=6ff83acc&prod&scoped=true&lang=css&"
import style1 from "./Loader.vue?vue&type=style&index=1&id=6ff83acc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff83acc",
  null
  
)

export default component.exports